import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import useSEO from "@/hooks/useSEO";
import useT from "@/i18n";

export default function NotFound() {
  const { t: T, lp } = useT();
  const t = T.notFound;
  useSEO({ title: t.seoTitle, description: t.seoDesc, path: window.location.pathname, robots: "noindex, follow", alternates: false });
  return (
    <section className="relative min-h-[70vh] flex items-center" aria-labelledby="nf-heading" data-testid="not-found-page">
      <div className="absolute inset-0 dot-grid opacity-30 pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-3xl mx-auto safe-x sm:px-8 text-center">
        <p className="font-mono-alt text-[#00BFFF] text-sm tracking-[0.3em]">{t.code}</p>
        <h1 id="nf-heading" className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mt-4">{t.title}</h1>
        <p className="mt-5 text-slate-400">{t.text}</p>
        <Link to={lp("/")} className="btn-primary mt-8" data-testid="nf-home-btn"><ArrowLeft size={16} aria-hidden="true" /> {t.back}</Link>
      </div>
    </section>
  );
}
